import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, Row, Col, Button } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { setFilters } from "../CustomerApprovedSlice";
import { fetchApprovedCustomerList } from "../CustomerApprovedThunk";
import SearchListAutoComplete from "../../../components/SearchListAutoComplete";
import {
  fetchCustomers,
  fetchUsers,
  fetchLocations,
} from "../../../store/commonThunks/lookups";

const CustomerApprovedFilters = ({ messageApi }) => {
  const dispatch = useDispatch();
  const { filters } = useSelector((state) => state.customerApproved);
  const lookups = useSelector((state) => state.lookups);

  const handleFilterChange = (field, value) => {
    dispatch(setFilters({ [field]: value }));
  };

  useEffect(() => {
    dispatch(fetchCustomers());
    dispatch(fetchUsers());
    dispatch(fetchLocations());
  }, [dispatch]);

  const handleReport = () => {
    let payload = { filterType: filters.filterType };
    if (filters.filterType === "Customer Wise")
      payload.customerId = filters.customerId || null;
    else if (filters.filterType === "User Wise")
      payload.userId = filters.userId || null;
    else if (filters.filterType === "Location Wise")
      payload.locationId = filters.locationId || null;

    dispatch(fetchApprovedCustomerList(payload)).then((res) => {
      if (res.meta.requestStatus === "fulfilled")
        messageApi.success("Approved Customers Loaded ✅");
      else messageApi.error("Failed to load records ❌");
    });
  };

  const renderExtraField = () => {
    switch (filters.filterType) {
      case "Customer Wise":
        return (
          <Col xs={24} sm={12} md={6} lg={4} className="customer-approved-filter-item">
            <label>Search Customer</label>
            <SearchListAutoComplete
              entityType="customer"
              optionsList={lookups.customers.map((e) => ({
                sale_id: e.acc_id,
                display_text: e.acc_name,
              }))}
              onSelect={(obj) => handleFilterChange("customerId", obj?.sale_id)}
              placeholder="Customer"
              showAddNew={false}
            />
          </Col>
        );
      case "User Wise":
        return (
          <Col xs={24} sm={12} md={6} lg={4} className="customer-approved-filter-item">
            <label>Search User</label>
            <SearchListAutoComplete
              entityType="user"
              optionsList={lookups.users.map((u) => ({
                sale_id: u.id,
                display_text: u.full_name,
              }))}
              onSelect={(obj) => handleFilterChange("userId", obj?.sale_id)}
              placeholder="User"
              showAddNew={false}
            />
          </Col>
        );
      case "Location Wise":
        return (
          <Col xs={24} sm={12} md={6} lg={4} className="customer-approved-filter-item">
            <label>Search Location</label>
            <SearchListAutoComplete
              optionsList={lookups?.locations?.map((loc) => ({
                sale_id: loc.location_id,
                display_text: loc.location_name,
              }))}
              onSelect={(obj) => handleFilterChange("locationId", obj?.sale_id)}
              placeholder="Location"
              showAddNew={false}
            />
          </Col>
        );
      default:
        return null;
    }
  };

  return (
    <Card className="mb-4 shadow-md rounded-xl">
      <Row className = "crm-filter-rows" gutter={[55,16]} style={{ alignItems: "center" }}>
        <Col xs={24} sm={12} md={6} lg={4} className="customer-approved-filter-item">
          <label>Filter Type</label>
          <SearchListAutoComplete
            optionsList={[
              { sale_id: "All", display_text: "All" },
              { sale_id: "User Wise", display_text: "User Wise" },
              { sale_id: "Location Wise", display_text: "Location Wise" },
              { sale_id: "Customer Wise", display_text: "Customer Wise" },
            ]}
            value={{ value: filters.filterType, label: filters.filterType }}
            onSelect={(obj) => handleFilterChange("filterType", obj?.sale_id)}
            placeholder="Filter Type"
            showAddNew={false}
          />
        </Col>
        {renderExtraField()}
        <Col
          xs={24} sm={12} md={6} lg={4}
          style={{ display: "flex", alignItems: "flex-end", paddingTop: "1rem" }}
        >
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleReport}
            style={{height: 35.19}}
            block
          >
            Get List
          </Button>
        </Col>
      </Row>
    </Card>
  );
};

export default CustomerApprovedFilters;
